module.exports = __webpack_public_path__ + "img/arrow-icon.e7d8fc29.svg";